import {useState} from 'react';
import {I18n} from 'aws-amplify/utils';
import {FlexiAddButton} from '@flexinet/ui-components';

import {CertificateRequestDrawer} from '../drawers/CertificateRequestDrawer';
import {useCertificateRequestConnections} from '../hooks/useCertificateRequestConnections';

// FNP-1193 — the Request control, and the hiding rule it obeys.
//
// ⚠️ HIDDEN, NOT DISABLED, when no connection can issue a certificate.
//
// A disabled button promises a capability that does not exist and invites the
// operator to go hunting for the permission that would enable it. An absent one
// is a correct statement about a tenant whose connections are all read-only.
// And the default is "hidden" in every UNKNOWN case too — loading, errored, no
// connections at all — because a control that appears optimistically and then
// fails at submit tells a tenant their credential is broken when the truth is
// that Flexi should never have offered the action.
//
// ⚠️ THE GATE IS THE CONNECTION LIST, NOT ONE CONNECTION'S SNAPSHOT, and that
// differs from the records module on purpose.
//
// The records module lives inside one zone, so it always knows which connection
// it is asking about. This module is a tenant-wide list with no connection in
// context — the operator picks one inside the form. So the question here is
// "does ANY connection pass the backend's gate", which is exactly what
// `useCertificateRequestConnections` filters for. If none does, there is
// nothing the form could offer and the button should not exist.
export const RequestCertificateButton = () => {

    const [opened, setOpened] = useState(false);

    const {
        connections,
        loading,
        isError,
    } = useCertificateRequestConnections();

    // Not permitted by default in every unknown case.
    if (loading || isError || connections.length === 0) {
        return null;
    }

    return (
        <>
            <FlexiAddButton onClick={() => setOpened(true)}>
                {I18n.get('Request Certificate')}
            </FlexiAddButton>
            <CertificateRequestDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
